import { createApp } from "vue";
import App from "./App.vue";
import { store } from "./store/store";

import { createI18n } from "vue-i18n";
const { defaultLocale, loadLocaleMessages } = require("./assets/languages/languages.js");

const i18n = createI18n({
  locale: defaultLocale,
  fallbackLocale: defaultLocale,
  messages: {},
});

import "bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";

import "bootstrap-icons/font/bootstrap-icons.css";
import "katex/dist/katex.min.css";

import "./assets/style/globalVars.scss";
import "./assets/style/main.scss";
import "./assets/style/uiComponents.scss";

async function bootstrap() {
  // Prefer browser language for first paint; App will switch to saved config language.
  const browserLang = (typeof navigator !== "undefined" && (navigator.language || "")).toLowerCase();
  let initial = defaultLocale;
  if (browserLang.startsWith("zh-tw") || browserLang.startsWith("zh-hk")) initial = "zh_tw";
  else if (browserLang.startsWith("zh")) initial = "zh_cn";
  else if (browserLang.startsWith("es")) initial = "es";
  else if (browserLang.startsWith("fr")) initial = "fr";
  else if (browserLang.startsWith("de")) initial = "de";
  else if (browserLang.startsWith("ja")) initial = "ja";
  else if (browserLang.startsWith("ko")) initial = "ko";
  else if (browserLang.startsWith("ru")) initial = "ru";
  else if (browserLang.startsWith("pt")) initial = "pt";

  await loadLocaleMessages(i18n.global, initial);

  const app = createApp(App);
  app.use(store);
  app.use(i18n);
  app.mount("#app");
}

bootstrap();
